
import { createTranslationResource } from '@backstage/frontend-plugin-api';
import { catalogReactTranslationRef } from '@backstage/plugin-catalog-react/alpha';
import { TranslationBlueprint } from '@backstage/plugin-app-react';

  export const catalogReactTranslations: any =  TranslationBlueprint.make({
      name: 'catalog-react-pt-BR',
      
      params: {
          resource: createTranslationResource({
              ref: catalogReactTranslationRef,
              translations: {
                  'pt-BR': () => import('./catalog-react-ptbr'),
              },
          }),
      },
  });